import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("cka_admin_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const publicApi = {
  listProducts: (params) => api.get("/products", { params }).then((r) => r.data),
  getProduct: (id) => api.get(`/products/${id}`).then((r) => r.data),
  getConfig: () => api.get("/config").then((r) => r.data),
  submitRequest: (data) => api.post("/requests", data).then((r) => r.data),
  submitContact: (data) => api.post("/contact", data).then((r) => r.data),
  getTracks: () => api.get("/tracks").then((r) => r.data),
  incrementTrackPlay: (id) => api.post(`/tracks/${id}/play`).then((r) => r.data),
  listGallery: () => api.get("/gallery").then((r) => r.data),
  listVideos: () => api.get("/videos").then((r) => r.data),
  listHoodieLogos: () => api.get("/hoodie-logos").then((r) => r.data),
  listProductReviews: (productId) => api.get(`/products/${productId}/reviews`).then((r) => r.data),
  submitReview: (data) => api.post("/reviews", data).then((r) => r.data),
  listTopReviews: (params) => api.get("/reviews/top", { params }).then((r) => r.data),
  quoteShipping: (data) => api.post("/shipping/quote", data).then((r) => r.data),
};

export const adminApi = {
  login: (email, password) =>
    api.post("/admin/auth/login", { email, password }).then((r) => r.data),
  me: () => api.get("/admin/me").then((r) => r.data),
  listProducts: () => api.get("/admin/products").then((r) => r.data),
  updateProduct: (id, data) =>
    api.patch(`/admin/products/${id}`, data).then((r) => r.data),
  deleteProduct: (id) => api.delete(`/admin/products/${id}`).then((r) => r.data),
  createProduct: (data) => api.post("/admin/products", data).then((r) => r.data),
  listRequests: () => api.get("/admin/requests").then((r) => r.data),
  updateRequest: (id, status) =>
    api.patch(`/admin/requests/${id}`, { status }).then((r) => r.data),
  listContacts: () => api.get("/admin/contacts").then((r) => r.data),
  listOrders: () => api.get("/admin/orders").then((r) => r.data),
  updateOrder: (id, status) =>
    api.patch(`/admin/orders/${id}`, { status }).then((r) => r.data),
  listGallery: () => api.get("/admin/gallery").then((r) => r.data),
  createGallery: (data) => api.post("/admin/gallery", data).then((r) => r.data),
  updateGallery: (id, data) => api.patch(`/admin/gallery/${id}`, data).then((r) => r.data),
  deleteGallery: (id) => api.delete(`/admin/gallery/${id}`).then((r) => r.data),
  getAnalytics: () => api.get("/admin/analytics").then((r) => r.data),
  listVideos: () => api.get("/admin/videos").then((r) => r.data),
  createVideo: (data) => api.post("/admin/videos", data).then((r) => r.data),
  updateVideo: (id, data) => api.patch(`/admin/videos/${id}`, data).then((r) => r.data),
  deleteVideo: (id) => api.delete(`/admin/videos/${id}`).then((r) => r.data),
  listHoodieLogos: () => api.get("/admin/hoodie-logos").then((r) => r.data),
  createHoodieLogo: (data) => api.post("/admin/hoodie-logos", data).then((r) => r.data),
  updateHoodieLogo: (id, data) => api.patch(`/admin/hoodie-logos/${id}`, data).then((r) => r.data),
  deleteHoodieLogo: (id) => api.delete(`/admin/hoodie-logos/${id}`).then((r) => r.data),
  listReviews: (params) => api.get("/admin/reviews", { params }).then((r) => r.data),
  updateReview: (id, data) => api.patch(`/admin/reviews/${id}`, data).then((r) => r.data),
  deleteReview: (id) => api.delete(`/admin/reviews/${id}`).then((r) => r.data),
};

export const orderApi = {
  createOrder: (data) => api.post("/orders", data).then((r) => r.data),
  getOrder: (reference) => api.get(`/orders/${reference}`).then((r) => r.data),
};
